// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__gM2Ga","addToCartBtn":"Counter_addToCartBtn__SX4pw"};